// extracted by mini-css-extract-plugin
export default {"profileSettingContainer":"ProfileSetting_profileSettingContainer__wMWKK","profileSetting":"ProfileSetting_profileSetting__R4J12","rightSide":"ProfileSetting_rightSide__4I0nP"};